<template>
  <div id="app">
    <div id="container">
      <Header :name="layout[0].name" />
      <Home :layout="layout" :lotto="lotto" />
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";

import Header from "./views/Header.vue";
import Home from "./views/Home.vue";

export default {
  name: "app",

  components: { Header, Home },
  data() {
    return { layout: null, lotto: null };
  },

  created() {
    this.$http
      .get(`${process.env.VUE_APP_BACKEND_API_URL}/lotto-reward/0`)
      .then(({ data }) => {
        this.lotto = data;
      })
      .catch((err) => {
        return err;
      });

    this.$http
      .get(`${process.env.VUE_APP_BACKEND_API_URL}/lotto/0`)
      .then(({ data }) => {
        this.layout = data;
      })
      .catch((err) => {
        return err;
      });
  },
  methods: {},
};
</script>

<style>
html {
  background: #f8f8f8;
}
#app {
  font-family: "Prompt", sans-serif;
  background: #f8f8f8;
}
#header {
  margin: 0px auto;
  width: 800px;
  text-align: center;
}

#container {
  width: 70%;
  /*height: 550px; */
  margin: 0px auto;
  padding: 0px;
}

@media (max-width: 575.98px) {
  #container {
    width: 100%;
  }
}
</style>
